export default "__VITE_ASSET__DLtMWgcC__"